<ng-container *ngIf="template">
  <div @tooltip>
    <ng-container *ngTemplateOutlet="template"></ng-container>
  </div>
</ng-container>
<div @tooltip *ngIf="!template">{{ text }}</div>
